
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'formly-email-panel',
    template: `

<div class="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-slate-900 dark:border-gray-700 dark:shadow-slate-700/[.7] mb-6">
    <div class="bg-gray-100 border-b rounded-t-xl py-3 px-4 md:py-4 md:px-5 dark:bg-slate-900 dark:border-gray-700">
      <p class="mt-1 text-lg text-gray-500 dark:text-gray-500">
      INFORMATIVA SULLA PRIVACY AI SENSI DEL REGOLAMENTO EUROPEO PER LA PROTEZIONE DEI DATI 2016/679
      </p>
    </div>
    <div class="p-4 md:p-5">
      <p class="text-md text-gray-800 dark:text-white">
      La informiamo che i dati personali e sensibili da lei forniti e quelli che eventualmente fornirà anche successivamente formeranno oggetto di trattamento nel rispetto della normativa sopra richiamata.
      </p>
      <h3 class="mt-2 text-lg font-semibold text-gray-500 dark:text-gray-400">
      Responsabile Protezione dei Dati
      </h3>
      <p>
      Per trattamento si intende la raccolta, registrazione, conservazione, elaborazione, modificazione, selezione, estrazione, raffronto, utilizzo, interconnessione, blocco, comunicazione, diffusione, cancellazione, distribuzione dei dati personali, ovvero la combinazione di due o più di tali operazioni.</p>
      <h3 class="mt-2 text-lg font-semibold">Titolare del trattamento e DPO</h3>
      Il titolare del trattamento dati è il Comune di San Lazzaro di Savena, con sede legale in piazza Bracci n. 1 San Lazzaro di Savena (BO).<br /> Il DPO (Responsabile della Protezione dei dati) a cui è possibile rivolgersi per esercitare i diritti di cui all'art. 13 del GDPR e/o per eventuali chiarimenti in materia di tutela dati personali, è disponibile all'indirizzo: mettere email
      <br />
      <h3 class="mt-2 text-lg font-semibold">Finalità e modalità del trattamento</h3>
      <p>Il Comune di San Lazzaro di Savena, titolare del trattamento, tratta i dati personali liberamenti conferiti, esclusivamente per finalità istituzionali.</p>
      <h3 class="mt-2 font-semibold text-lg">Consenso</h3>
      <p>Il consenso del trattamento ai fini istituzionali è necessario ed obbligatorio per le finalità stesse.</p>
      <h3 class="mt-2 font-semibold text-lg">Periodo di conservazione</h3>
      <p>I dati personali verranno conservati per un arco di tempo non superiore al conseguimento delle finalità per le quali i dati personali sono trattati (finalità istituzionali e non commerciali). </p>
      <h3 class="mt-2 font-semibold text-lg">Diritti del cittadino/interessato</h3>
      Il cittadino/L’interessato avrà in qualsiasi momento piena facoltà di esercitare i diritti previsti dalla normativa vigente; potrà far valere i propri diritti rivolgendosi al Comune di San Lazzaro di Savena, scrivendo all’indirizzo mettere email <br />
<p><strong>I diritti del cittadino/dell’interessato sono quelli previsti dal Regolamento UE 2016/679 (GDPR).</strong></p>
<p>Il cittadino/L’interessato può:</p>
<div class="grid">
<p>ricevere conferma dell’esistenza dei dati suoi personap e richiedere l’accesso al loro contenuto;</p>
<p>aggiornare, modificare e/o correggere i suoi dati personap;</p>
<p>chiedere la cancellazione, la trasformazione in forma anonima, il blocco dei suoi dati trattati in violazione di legge;</p>
<p>chiedere la pmitazione del trattamento;</p>
<p>opporsi per motivi legittimi al trattamento;</p>
</div>
<ng-container #fieldComponent></ng-container>

    </div>
  </div>




  `,
    standalone: true,
    imports: [FormlyModule, ReactiveFormsModule]
})
export class PanelPrivacyComponent extends FieldWrapper {
}
